// extracted by mini-css-extract-plugin
module.exports = {"partnersContainer":"Partners_partnersContainer__97eAN","headingText":"Partners_headingText__cOMB_","contentRow":"Partners_contentRow__2_9WP","bodyText":"Partners_bodyText__EfqqZ"};